const getVideoFilePath = (path, file) => {
  const storageUrl = process.env.GATSBY_STORAGE_URL;
  const hasTrailingSlash = path[path.length - 1] === '/';
  return `${storageUrl}${path.trim()}${!hasTrailingSlash ? '/' : ''}${file}?cache=none`;
}

export default getVideoFilePath;
